
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.582 30.438c.018-3.407-3.497-5.423-6.907-6.892-3.397-1.462-4.481-2.694-4.481-5.334 0-1.582 1.036-1.067 1.49-3.97.193-1.203 1.108-.019 1.284-2.766 0-1.095-.5-1.367-.5-1.367s.254-1.62.353-2.868c.102-1.307-.637-4.096-3.682-4.952-.531-.546-.891-1.411.747-2.279C10.302-.156 9.47 1.72 7.56 3.098c-1.624 1.21-2.062 3.125-1.984 4.144a49.05 49.05 0 00.357 2.87s-.503.271-.503 1.365c.176 2.75 1.095 1.564 1.285 2.767.455 2.902 1.493 2.387 1.493 3.97 0 2.64-.34 3.536-3.738 4.998C1.06 24.679 0 27.032.018 30.438.022 31.456 0 31.83 0 31.83h25.6s-.022-.374-.018-1.393zM27.2 15.83v-4.8H24v4.8h-4.8v3.2H24v4.8h3.2v-4.8H32v-3.2h-4.8z","fill":"#B6B6B6"}})])
          )
        }
      }
    